
import { Component, Mixins } from 'vue-property-decorator';
import HomeSNS from './';
@Component
export default class HomeSNSEn extends Mixins(HomeSNS) {
}
